import styled from 'styled-components'

export const DrawerContainerHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
`
